export default "__VITE_ASSET__CsyImoL9__"